import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { IMPRESSIONEVENTS, INTERACTEVENTS, TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  private telemetryService = inject(TelemetryService);
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<ConfirmDialogModel>(MAT_DIALOG_DATA);

  title: string;
  message: string;

  constructor() {
    const data = this.data;

    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    // telemtry  API CALL and, send data
    this.telemetryService.impression({
      type: IMPRESSIONEVENTS.VIEW,
      itype: 'Component',
      pageid: 'ConfirmDialogComponent',
      detail: 'OnInit Load',
    });
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'ConfirmDialogComponent',
      detail: 'onConfirm() invoked for confirm the attachment or not',
    });
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'ConfirmDialogComponent',
      detail: 'onDismiss() invoked for confirm the attachment or not',
    });
    this.dialogRef.close(false);
  }
  ngOnDestroy() {
    // telemtry end call
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'ConfirmDialogComponent',
      detail: 'ngOnDestroy() called',
    });
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
  ) {}
}
